import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../constants";
import { ShareContext } from "../context/ShareContext";
import BackLoader from "../components/backloader";
import JisButton from "../components/controls/jisButton";

function MyDraftCases() {
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData, setIsExpired } =
    useContext(ShareContext);
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    onLoad();
  }, []);

  const onLoad = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(`${Constants.apiUrl}/filing/get-my-draft`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setCases(data.cases);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onContinue = (caseid) => {
    navigate(`/case-filing/${caseid}`);
  };
  return (
    <div>
      <div>
        <div class="table-header">
          <p> Draft </p>
        </div>
        <div className="table-wrapper ">
          <table className="case-details-table full-border">
            <thead>
              <tr>
                <th className="col-title">Suit Number</th>
                {/* <th className="col-title">Case Title</th>
              <th className="col-medium">Filing Type</th>
              <th className="col-medium">Classification</th> */}
                <th className="col-medium">Date Initiated</th>
                {/* <th className="col-medium">Status Level</th> */}

                {/* <th>Resume Filing</th> */}
                <th className="col-action">Action</th>
              </tr>
            </thead>
            <tbody>
              {cases.map((opt, index) => (
                <tr key={index}>
                  <td>{opt.referenceNumber || "N/A"}</td>
                  {/* <td>{opt.caseTitle}</td>
                <td>
                  {
                    Constants.getItemById(
                      frequentData?.casetype,
                      opt.caseTypeId
                    )?.caseType1
                  }
                </td>
                <td>
                  {" "}
                  {
                    Constants.getItemById(
                      frequentData?.casecategories,
                      opt.caseCategoryId
                    )?.categoryTitle
                  }
                </td> */}
                  <td>
                    {" "}
                    {Constants.momentDate(opt.createdOn).format(
                      "DD MMM, YYYY"
                    ) || "N/A"}
                  </td>
                  {/* <td>Case is Draft Mode</td> */}
                  <td>
                    <JisButton
                      variant="plain"
                      onClick={() => onContinue(opt.caseId)}
                    >
                      Continue Filing
                    </JisButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <BackLoader open={loading} />
    </div>
  );
}

export default MyDraftCases;
